export default __webpack_public_path__ + "static/media/pin_pickup.78b7b865.svg";